import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { AssistantPlaceholderWrapper } from "./AssistantPlaceholder.styled";

const AssistantPlaceholder = ({
  children,
  height,
  mobileWidth,
  tabletWidth,
  desktopWidth,
  showAssistant,
  hideAssistant
}) => {
  const ref = useRef();
  useEffect(() => {
    function updatePosition() {
      showAssistant(ref);
    }

    window.addEventListener("resize", updatePosition);
    // Wait for render to complete to move things
    setTimeout(() => {
      showAssistant(ref);
    }, 0);

    return () => {
      window.removeEventListener("resize", updatePosition);
      hideAssistant();
    };
  }, []);

  return (
    <AssistantPlaceholderWrapper
      ref={ref}
      data-testid="assistant-placeholder"
      $height={height}
      $mobileWidth={mobileWidth}
      $tabletWidth={tabletWidth}
      $desktopWidth={desktopWidth}
    >
      {children}
    </AssistantPlaceholderWrapper>
  );
};
AssistantPlaceholder.displayName = "AssistantPlaceholder";
AssistantPlaceholder.propTypes = {
  children: PropTypes.node,
  height: PropTypes.string,
  mobileWidth: PropTypes.string,
  tabletWidth: PropTypes.string,
  desktopWidth: PropTypes.string,
  showAssistant: PropTypes.func.isRequired,
  hideAssistant: PropTypes.func.isRequired
};
export default AssistantPlaceholder;
